import { IconWrapper } from '../runtime';
export default IconWrapper('ofd-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 25 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0.5 3.75C0.5 1.67893 2.17893 0 4.25 0H20.75C22.8211 0 24.5 1.67893 24.5 3.75V20.25C24.5 22.3211 22.8211 24 20.75 24H4.25C2.17893 24 0.5 22.3211 0.5 20.25V3.75Z",
      "fill": 'url(#' + props.id + 'e952fc9b' + ')'
    }
  }), h("path", {
    "attrs": {
      "d": "M18.9543 8.61847C17.368 7.54596 15.1941 7.71192 13.7897 9.11633L10.906 12L10.9072 12.0012L9.61812 13.2915C9.6014 13.3082 9.58444 13.3245 9.56725 13.3405L8.99351 13.9142C8.28314 14.6246 7.47173 15.2224 6.58758 15.6895C8.1001 16.4019 9.96012 16.1326 11.2098 14.8817L14.089 12L14.0872 11.9983L14.8154 11.27L15.8784 12.333L16.939 11.2723L15.9762 10.3095C16.3961 10.1366 16.8673 10.1266 17.2931 10.2797L18.9543 8.61847Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.3717 11.3223C18.6339 11.9804 18.4987 12.76 17.966 13.2927C17.2521 14.0066 16.0946 14.0066 15.3807 13.2927L15.1474 13.0594L13.5564 14.6504L13.7897 14.8837C15.3823 16.4763 17.9644 16.4763 19.557 14.8837C20.9755 13.4652 21.1306 11.2618 20.0223 9.6717L18.3717 11.3223Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M7.24289 13.4723C7.16974 13.4183 7.09969 13.3583 7.03347 13.292C6.3199 12.5785 6.3199 11.4215 7.03347 10.708C7.74727 9.99417 8.90464 9.99443 9.61811 10.7085L9.84788 10.9385L11.4389 9.34753L11.2098 9.11827C9.61778 7.5248 7.03523 7.52422 5.44248 9.11698C3.9196 10.6399 3.85325 13.0677 5.24342 14.6694C5.9624 14.3634 6.63506 13.9604 7.24289 13.4723Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + 'e952fc9b',
      "x1": "24.5",
      "y1": "24",
      "x2": "0.5",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "offset": "0.029618",
      "stop-color": "#0A6CFF"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#29A9FF"
    }
  })])])]);
});